var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "rewardbox", staticClass: "reward-rules" }, [
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "rules-list" }, [
      _c("li", { staticClass: "rules-item" }, [
        _c("p", { staticClass: "item-title" }, [
          _c("img", {
            attrs: {
              src: require("../assets/img/rulesimg/sort-1.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("集星赢奖励")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item-content" }, [
          _c("span", [
            _vm._v(
              "即日起-**时间，转发视频并集星，就有机会成为飞鹤品鉴之星，获得千元大奖"
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "table-box" }, [
            _c("li", { staticClass: "table-header" }, [
              _c("span", [_vm._v("奖项名称")]),
              _vm._v(" "),
              _c("span", [_vm._v("评选总名额")]),
              _vm._v(" "),
              _c("span", [_vm._v("奖励")])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "table-tbody" }, [
              _c("span", [_vm._v("飞鹤证言大使")]),
              _vm._v(" "),
              _c("span", [_vm._v("1-200名")]),
              _vm._v(" "),
              _c("span", [_vm._v("华为 HUAWEI P40 5G手机")])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "table-tbody" }, [
              _c("span", [_vm._v("飞鹤品鉴之星")]),
              _vm._v(" "),
              _c("span", [_vm._v("201-1200名")]),
              _vm._v(" "),
              _c("span", [_vm._v("华为 360扫地机器人X90")])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "table-tbody" }, [
              _c("span", [_vm._v("飞鹤新鲜品鉴官")]),
              _vm._v(" "),
              _c("span", [_vm._v("1201-11200名")]),
              _vm._v(" "),
              _c("span", [_vm._v("美维士蔓越莓益生菌")])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "table-tbody" }, [
              _c("span", [_vm._v("飞鹤新鲜品鉴达人")]),
              _vm._v(" "),
              _c("span", [_vm._v("11201-31200名")]),
              _vm._v(" "),
              _c("span", [_vm._v("飞鹤茁然儿童配方液态奶(200ml*6瓶)")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "rules-item" }, [
        _c("p", { staticClass: "item-title" }, [
          _c("img", {
            attrs: {
              src: require("../assets/img/rulesimg/sort-2.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("集星方式说明")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item-content" }, [
          _c("span", { staticClass: "reminder-title" }, [
            _vm._v(
              "朋友圈/微信群分享盲测小视频+您的真实观看感受(使用体验)，就可以开始集星啦！"
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "reminder-title" }, [
            _vm._v("温馨提示您：")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "reminder-item" }, [
            _vm._v(
              "①集星总量=微信朋友圈点赞量&评价量+微信群内转发获得的点赞量&评价量"
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "reminder-item" }, [
            _vm._v(
              "②消费者获得点赞量（或评论量）不低于50条才可参与评选，负面评价的点赞不计入点赞总量"
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "reminder-item" }, [
            _vm._v("③如出现点赞量（或评论量）相同者，按照时间先后顺序取值")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "reminder-item" }, [
            _vm._v("④该活动仅限于微信内转发集星，其他转发不计入参赛范围内")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "reminder-item" }, [
            _vm._v("⑤点赞数据采集全部通过系统导出相应的数据")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "rules-item" }, [
        _c("p", { staticClass: "item-title" }, [
          _c("img", {
            attrs: {
              src: require("../assets/img/rulesimg/sort-3.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("奖励发放说明")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item-content" }, [
          _c("span", [
            _vm._v(
              "活动结束后，由飞鹤消费者服务部联系消费者提供个人地址信息，将奖品邮寄到家。飞鹤全国服务热线电话：400-710-2768"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "rules-footer" }, [
        _c("p", { staticClass: "notes" }, [
          _c("span", [_vm._v("注：")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "所有评选经过正规公证机构全程跟踪、公证，星妈会（全站广告位、或首页轮播图位）公示中奖者微信号及手机号（滚动公示一个月），后台信息保留至兑现完毕"
            )
          ])
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("../assets/img/rulesimg/rules-footer.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "footer-tip" }, [
          _vm._v("解释权归飞鹤乳业有限公司")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de97ec42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de97ec42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/indexMsg.vue
// module id = null
// module chunks = 